/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-11-29 17:24:44
 * @LastEditors: changfeng
 * @LastEditTime: 2022-11-30 16:06:12
 */
// import * as antd from "../components/antd/index";
import {
  DateWidget,
  DateTimeWidget,
  TimeWidget,
  SelectWidget,
  TextWidget,
  TextAreaWidget,
  NumberWidget,
  SliderWidget,
  RangeWidget,
  BooleanWidget,
  MultiSelectWidget,
  AutocompleteWidget,
  TreeSelectWidget,
  FieldSelect,
  FieldDropdown,
  FieldCascader,
  FieldTreeSelect,
  Button,
  ButtonGroup,
  Conjs,
  Switch,
  ValueSources,
  confirm,
  Provider,
} from '../components/antd/index';
import React from 'react';
// const {
//   VanillaFieldSelect,
//   VanillaConjs,
//   VanillaButton,
//   VanillaButtonGroup,
//   VanillaProvider,
//   VanillaValueSources,
//   vanillaConfirm,
//   VanillaSwitch,
// } = Widgets;

// const {
//   DateWidget,
//   DateTimeWidget,
//   TimeWidget,
//   SelectWidget,
//   TextWidget,
//   TextAreaWidget,
//   NumberWidget,
//   SliderWidget,
//   RangeWidget,
//   BooleanWidget,
//   MultiSelectWidget,
//   AutocompleteWidget,
//   TreeSelectWidget,

//   FieldSelect,
//   FieldDropdown,
//   FieldCascader,
//   FieldTreeSelect,

//   Button,
//   ButtonGroup,
//   Conjs,
//   Switch,
//   ValueSources,
//   confirm,

//   Provider,
// } = antd
export const settings = {
  formatField: (
    field,
    parts,
    label2,
    fieldDefinition,
    config,
    isForDisplay,
  ) => {
    if (isForDisplay) return label2;
    else return field;
  },
  renderField: (props) => <SelectWidget {...props} />,
  renderOperator: (props) => <SelectWidget {...props} />,
  renderFunc: (props) => <SelectWidget {...props} />,
  renderConjs: (props) => <Conjs {...props} />,
  renderSwitch: (props) => <Switch {...props} />,
  renderButton: (props) => <Button {...props} />,
  renderButtonGroup: (props) => <ButtonGroup {...props} />,
  renderProvider: (props) => <Provider {...props} />,
  renderValueSources: (props) => <ValueSources {...props} />,
  renderConfirm: confirm,
  renderSwitchPrefix: () => <>{'Conditions'}</>,

  // renderField: (props) => <VanillaFieldSelect {...props} />,
  // renderOperator: (props) => <VanillaFieldSelect {...props} />,
  // renderFunc: (props) => <VanillaFieldSelect {...props} />,
  // renderConjs: (props) => <VanillaConjs {...props} />,
  // renderSwitch: (props) => <VanillaSwitch {...props} />,
  // renderButton: (props) => <VanillaButton {...props} />,
  // renderButtonGroup: (props) => <VanillaButtonGroup {...props} />,
  // renderProvider: (props) => <VanillaProvider {...props} />,
  // renderValueSources: (props) => <VanillaValueSources {...props} />,
  // renderConfirm: vanillaConfirm,
  // renderSwitchPrefix: () => <>{"Conditions"}</>,

  valueSourcesInfo: {
    value: {},
  },
  fieldSeparator: '.',
  fieldSeparatorDisplay: '.',
  renderSize: 'small',
  maxLabelsLength: 100,
  canReorder: true,
  canRegroup: true,
  showLock: false,
  canDeleteLocked: false,
  showNot: true,
  canLeaveEmptyGroup: true,
  shouldCreateEmptyGroup: false,
  forceShowConj: false,
  canShortMongoQuery: true,
  removeEmptyGroupsOnLoad: true,
  removeIncompleteRulesOnLoad: true,
  removeInvalidMultiSelectValuesOnLoad: true,
  groupActionsPosition: 'bottomLeft', // oneOf [topLeft, topCenter, topRight, bottomLeft, bottomCenter, bottomRight]
  setOpOnChangeField: ['keep', 'default'], // 'default' (default if present), 'keep' (keep prev from last field), 'first', 'none'
  groupOperators: ['some', 'all', 'none'],

  convertableWidgets: {
    number: ['slider', 'rangeslider'],
    slider: ['number', 'rangeslider'],
    rangeslider: ['number', 'slider'],
    text: ['textarea'],
    textarea: ['text'],
  },

  // localization
  locale: {
    moment: 'en',
  },
  valueLabel: 'Value',
  valuePlaceholder: 'Value',
  fieldLabel: 'Field',
  operatorLabel: 'Operator',
  funcLabel: 'Function',
  fieldPlaceholder: 'Select field',
  funcPlaceholder: 'Select function',
  operatorPlaceholder: 'Select operator',
  lockLabel: 'Lock',
  lockedLabel: 'Locked',
  deleteLabel: null,
  addGroupLabel: 'Add group',
  addCaseLabel: 'Add condition',
  addDefaultCaseLabel: 'Add default condition',
  defaultCaseLabel: 'Default:',
  addRuleLabel: 'Add rule',
  addSubRuleLabel: 'Add sub rule',
  delGroupLabel: '',
  notLabel: 'Not',
  valueSourcesPopupTitle: 'Select value source',
  removeRuleConfirmOptions: null,
  removeGroupConfirmOptions: null,

  defaultGroupConjunction: 'AND',
  jsonLogic: {
    groupVarKey: 'var',
    altVarKey: 'var',
    lockedOp: 'locked',
  },
};
